import React, {Component, Fragment} from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import {Poll} from "@irati/types"
import {IconTypes} from "@irati/ui/src/Icon"
import modalStory, {anyStoriesOpen} from "@irati/utils/modalStory"
import History from "@irati/utils/history"
import GenericModal from "@irati/ui/src/GenericModal"
import {IconButton} from "@irati/ui/src/Button"
import Spacing from "@irati/ui/src/Spacing"

import ViewPoll from "./ViewPoll"
import ViewVotes from "./ViewVotes"
import {ModalHeader} from "../shared/Modal"

export const VIEW_POLL = "VIEW_POLL"
export const VIEW_VOTES = "VIEW_VOTES"

const modals = [VIEW_POLL, VIEW_VOTES]

const Image = styled.img`
  display: block;
  width: 150px;
  height: 150px;
  margin: 0 auto;
`

const Back = styled(IconButton)`
  position: absolute;
  top: 10px;
  left: 10px;
  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    top: 20px;
    left: 20px;
  `}
`

interface Props {
  redirectToFeed: boolean
  poll: Poll
  onAfterExitModal: () => void
}

interface State {
  show: {[key: string]: string}
}

class PollsPopup extends Component<Props, State> {
  state = {
    show: modalStory(modals, VIEW_POLL)
  }

  static defaultProps = {
    redirectToFeed: false,
    onAfterExitModal: null
  }

  static contextTypes = {
    appPath: PropTypes.string.isRequired
  }

  show = (modalToShow = VIEW_POLL) =>
    this.setState({
      show: modalStory(modals, modalToShow)
    })

  handleHide = () =>
    this.setState({
      show: modalStory(modals, null)
    })

  handleAfterExit = () => {
    const {redirectToFeed, onAfterExitModal} = this.props
    if (!anyStoriesOpen(this.state.show)) {
      if (redirectToFeed) {
        History.push("/polls", this.context, false)
      }
      if (typeof onAfterExitModal === "function") {
        onAfterExitModal()
      }
    }
  }

  render() {
    const {show} = this.state
    const {poll} = this.props

    return (
      <Fragment>
        <GenericModal show={show[VIEW_POLL]} onHide={this.handleHide} onExited={this.handleAfterExit} hideActions>
          <Spacing marginBottom={1}>
            <ModalHeader users={poll?.winners?.results.map((w) => w.user)} size={150} trophy={poll.trophy} />
          </Spacing>
          <ViewPoll poll={poll} selectScreen={this.show} onDelete={this.handleHide} />
        </GenericModal>
        <GenericModal show={show[VIEW_VOTES]} onHide={this.handleHide} onExited={this.handleAfterExit} hideActions>
          <Image src={poll?.trophy?.href} alt={poll?.trophy?.alt} />
          <Back inline={false} icon={IconTypes.arrowLeft} onClick={() => this.show(VIEW_POLL)} />
          <ViewVotes poll={poll} />
        </GenericModal>
      </Fragment>
    )
  }
}

export default PollsPopup
